module.exports = __webpack_public_path__ + "img/cp-18.899af258.jpg";